import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Resolve links only against records already authorized and loaded for this page.
export function useDynamicsRecordLink(records, openRecord) {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = Number(params.get('openRecord'));
    if (!id) return;
    const record = records.find(item => item.id === id);
    if (!record) return;
    params.delete('openRecord');
    openRecord(record);
    navigate({pathname:location.pathname,search:params.toString(),hash:location.hash}, {replace:true,state:location.state});
  }, [location, records, openRecord, navigate]);
}
